import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import SlidingSideBar from '../SlidingSideBar/SlidingSideBar';
import FilePopup from './FilePopup';
import ReportCard from './ReportCard';

const HistoryPreview = ({ reports, showHistory, onCloseHistory, dockPosition, handleHideGeneratedFileFromReport }) => {
  const [previewFile, setPreviewFile] = useState(null);

  const handleViewPdf = file => {
    handleHideGeneratedFileFromReport();
    setPreviewFile(file);
  };

  return (
    <SlidingSideBar
      width="50%"
      visible={showHistory}
      onClose={onCloseHistory}
      title="Report History"
      fullScreen={false}
      dock={dockPosition}
    >
      <Container className="mt-4 mb-4">
        {reports.length === 0 ? (
          <p className="text-muted">No files generated yet.</p>
        ) : (
          reports.map(report => <ReportCard key={report._id} report={report} onViewPdf={handleViewPdf} />)
        )}
      </Container>

      {previewFile && <FilePopup file={previewFile} onHide={() => setPreviewFile(null)} isDownloadable={true} />}
    </SlidingSideBar>
  );
};

export default HistoryPreview;
